/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FC } from 'react';

import * as Styles from '@components/modals/styles';
import { swapCancel } from '@lib/beacon';
import { testNodeHealth } from '@utils/node';
import { AlertDialog } from '@versumstudios/ui';

export interface ISwapCancel {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  swapId?: number;
}

export const SwapCancel: FC<ISwapCancel> = ({ open, onOpenChange, swapId }) => {
  const handleConfirm = async () => {
    await testNodeHealth();
    swapCancel(swapId!);

    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      title="Cancel Swap"
      description="You're about to cancel a swap on this token."
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content />
    </AlertDialog>
  );
};
